import { render, staticRenderFns } from "./ServiceinvoiceIndex.vue?vue&type=template&id=b7969594"
import script from "./ServiceinvoiceIndex.vue?vue&type=script&lang=js"
export * from "./ServiceinvoiceIndex.vue?vue&type=script&lang=js"
import style0 from "./ServiceinvoiceIndex.vue?vue&type=style&index=0&id=b7969594&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports